import numeral from 'numeral'

// 格式化字符串或者数字，一般用于金额
export function formatNumber(number, template?: any) {
  // 10000	 '0,0.00'	'1,000.00'
  // 1         '0%'	  '100%'
  return numeral(number).format(template || '0.00')
}

// 格式化金额。金额默认小数点3位
export function formatMoney(number: any, template?: any) {
  if (number || number === 0)
    return formatNumber(number, typeof template === 'undefined' ? '0,0.00' : template)
  return number
}

// 字符串转数字
export const parseMoneyToNumber = (moneyStr) => {
  if (!moneyStr && moneyStr !== 0) return 0;

  if (typeof moneyStr === 'number') return moneyStr;

  const cleanedStr = moneyStr.toString().replace(/,/g, '');
  const number = parseFloat(cleanedStr);

  return Number.isNaN(number) ? 0 : number;
};

// 格式化比率
export function formatRatio(number, template?) {
  if (number || number === 0) return formatNumber(number, template || '0.00%')
  return number
}

export function isNumber(value) {
  if (typeof value === 'number') {
    return !Number.isNaN(value)
  }

  return Object.prototype.toString.call(value) === '[object Number]'
}

// 判断一个值是否是数字或“类似数字”的字符串
export function isNumeric(value) {
  // 如果值是字符串类型，使用正则表达式检查它是否可以表示一个数字（包含负数和小数）
  if (typeof value === 'string') {
    return /^-?\d*\.?\d*$/.test(value)
  }

  // 对于非字符串值，调用isNumber函数进行检查
  return isNumber(value)
}

/**
 * 将逗号隔开的数字字符串转换为范围表示
 * @param input - 逗号隔开的数字字符串
 * @returns 转换后的范围字符串
 */
export function convertStringNumberToRange(input: string): string {
  // 边界判断：如果输入为空或者不是字符串
  if (!input || typeof input !== 'string') {
    return '';
  }

  // 将字符串分割为数字数组
  let numbers = input.split(',').map(num => parseFloat(num)).filter(num => !isNaN(num));

  // 边界判断：如果数字数组为空
  if (numbers.length === 0) {
    return '';
  }

  // 对数字数组进行排序
  numbers = [...new Set(numbers)].sort((a, b) => a - b);

  // 获取最小和最大值
  const min = numbers[0];
  const max = numbers[numbers.length - 1];

  // 边界判断：如果最大值和最小值相等
  if (min === max) {
    return `${min}`;
  }

  // 返回范围表示
  return `${min}~${max}`;
}
